<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form action="#" v-on:submit.prevent="handleSubmit(saveUser)" class="main-form needs-validation" novalidate>
      <div class="row mb-15">
        <div class="col-md-6 mb-20">
          <ValidationProvider name="First Name" rules="required" v-slot="{ errors }">
          <input v-model="firstName" type="text" class="form-control " placeholder="First Name *" >
          <div class="invalid-feedback">{{errors[0]}}</div>
          </ValidationProvider>
        </div>
        <div class="col-md-6 mb-20">
          <ValidationProvider name="Last Name" rules="required" v-slot="{ errors }">
          <input v-model="lastName" type="text" class="form-control " placeholder="Last Name *" >
          <div class="invalid-feedback">{{errors[0]}}</div>
          </ValidationProvider>
        </div>										
        <div class="col-md-6 mb-20">
          <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
          <input v-model="email" type="email" class="form-control " placeholder="Email *">
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback"> {{ errors[0] }}</div>
          </ValidationProvider>
        </div>

        <div class="col-md-6 mb-20">
          <ValidationProvider name="password" rules="confirmed:confirmation" v-slot="{ errors }">
          <input v-model="password" type="password" class="form-control " placeholder="Password *">
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback">
            {{ errors[0] }}
          </div>
          </ValidationProvider>
        </div>
        <div class="col-md-6 mb-20">
          <ValidationProvider name="confirmation" vid="confirmation" v-slot="{ errors }">
          <input v-model="password_confirmation" type="password" class="form-control " placeholder="Confirm Password *" >
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>

        <div class="col-md-6 mb-20">
          <ValidationProvider name="Phone" rules="min:7|required" v-slot="{ errors }" v-mask="'(###)###-####'">
          <input v-model="phone" type="text" class="form-control " placeholder="Phone *">
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="col-md-6 mb-20">
          <ValidationProvider name="Address 1" rules="required" v-slot="{ errors }">
          <input v-model="address1" type="text" class="form-control" placeholder="Address 1 *" >
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback"> {{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="col-md-6 mb-20">
          <ValidationProvider name="City" rules="required" v-slot="{ errors }">
          <input v-model="city" type="text" class="form-control " id="validationServer05" placeholder="City *">
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="col-md-6 mb-20">
          <div>
            <ValidationProvider name="State" rules="required" v-slot="{ errors }">
            <select v-model="state" class="custom-select h-100" id="validationServer044" >
              <option :value="null" disabled selected hidden>State</option>
              <option v-for="state in states" :key="state.id" :value="state.id" > {{ state.name }}</option>
            </select>
            <!-- <div class="valid-feedback">Looks good!</div> -->
            <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6 mb-20">
          <ValidationProvider name="Zip Code" rules="required" v-slot="{ errors }">
          <input v-model="zipCode" type="text" class="form-control " placeholder="Zip Code *" >
          <!-- <div class="valid-feedback">Looks good!</div> -->
          <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="col-md-12 mb-20">
          <div>
            <!-- <input class="form-control" id="validationServer07" required> -->
            <Autocomplete 
                :items="airportsQuery"
                v-model="homeAirport"
                :get-label="getLabel"
                :component-item='template'
                :input-attrs="airportInput"
                @update-items="updateAirports">
            </Autocomplete>
            <!-- <div class="valid-feedback">Looks good!</div> -->
            <!-- <div class="invalid-feedback">Please provide a valid Home airport.</div> -->
          </div>
        </div>
        <div class="col-md-8 mb-20">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="legalAge">
            <label class="form-check-label" for="inlineCheckbox1">I'm over 18 years old</label>
          </div>
				</div>

      </div>
      <div class="text-center">
        <button class="btn btn-primary px-40" type="submit">{{ buttonText }}</button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import axios from 'axios';
import AirportTemplate from '@/views/Trips/Templates/AirportTemplate'
import Autocomplete from 'v-autocomplete';
import 'vue2-datepicker/index.css';

export default {
  components: {
    Autocomplete,
  },
  props: {
    user: {
      type: Object,
      default: () => ({
        id: 0,
        email: '',
        first_name: '',
        last_name: '',
        contact_name: '',
        legal_age: false,
        phone: '',
        address_1: '',
        address_2: '',
        zip: '',
        city: '',
        airport_id: '',
        role_id: '',
        state_id: '',
        airport: {}
      })
    },
    buttonText: {
      type: String,
      default: "Save"
    }
  },
  data(){
    return {
      email: this.user.email,
      firstName: this.user.first_name,
      lastName: this.user.last_name,
      password:'',
      password_comfirmation:'',
      phone: this.user.phone,
      address1: this.user.address_1,
      legalAge: this.user.legal_age,
      city: this.user.city,
      state: this.user.state_id,
      zipCode: this.user.zip,
      homeAirport: this.user.airport,
      states:[],
      airportsQuery: [ this.user.airport ],
      template: AirportTemplate,
      airportInput: {
        placeholder:'Nearest Airport',
        class:'form-control',
      },
    }
  },
  created() {
    this.fetchStates();
  },
  methods: {
    afterToday(date) {
      return date > new Date(new Date()/* .setHours(23, 59, 59, 59) */);
    },
    fetchStates(){
      axios.get("/api/states").then(res => {
        this.states = res.data.data.states;
      });
    },
    getLabel(item) {
      if (item) {
        return item.name;	
      }
      else {
        this.airportsQuery = [];
        return null;
      }
    },
    getUserData() {
      let params =  {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        phone: this.phone,
        address_1: this.address1,
        legal_age: this.legalAge,
        city: this.city,
        zip: this.zipCode,
        airport_id: this.homeAirport ? this.homeAirport.id : null,
        state_id: this.state
      };

      if (this.password.length > 0)
      {
        params.password = this.password;
      }

      return params;
    },
    updateAirports(text) {
      if (text) {
        axios.get("/api/airports/search?filter[search]="+text).then(res => this.airportsQuery = res.data.data.airports);
      }
    },
    saveUser() {
      this.$emit('saveUser', this.getUserData())
    }
  }
}
</script>

<style>

</style>